import { jsx as _jsx } from "preact/jsx-runtime";
import { render } from 'preact/compat';
import { ConfirmContent } from './ConfirmContent.js';
import { ConnectingContent } from './ConnectingContent.js';
import { getLangText } from './lang.js';
import { Modal } from './Modal.js';
import { SelectAccount } from './SelectAccount.js';
import { modalStyleSheetContent } from './style.js';
function prepareDomNode() {
    const div = document.createElement('div');
    const style = document.createElement('style');
    style.innerHTML = modalStyleSheetContent;
    document.body.append(style);
    document.body.append(div);
    function onClose() {
        div.remove();
        style.remove();
    }
    return {
        onClose,
        div,
    };
}
export function openConnectingModal() {
    const { onClose, div } = prepareDomNode();
    const langText = getLangText();
    render(_jsx(Modal, Object.assign({ title: langText.loadingTitle, onClose: onClose }, { children: _jsx(ConnectingContent, {}) })), div);
    return onClose;
}
export function openVerifyAddressModal(address) {
    const { onClose, div } = prepareDomNode();
    const langText = getLangText();
    render(_jsx(Modal, Object.assign({ width: 550, title: langText.loadingTitle, onClose: onClose }, { children: _jsx(ConfirmContent, { address: address }) })), div);
    return onClose;
}
export function openSelectAccountModal(options) {
    const { onClose, div } = prepareDomNode();
    const langText = getLangText();
    return new Promise((resolve, reject) => {
        function onConfirm(account) {
            resolve(account);
            onClose();
        }
        function onCancel() {
            reject(new Error('Operation is canceled.'));
            onClose();
        }
        render(_jsx(Modal, Object.assign({ title: langText.loadingTitle, onClose: onCancel }, { children: _jsx(SelectAccount, { accounts: options.accounts, selectedIndex: options.selectedIndex || 0, onConfirm: onConfirm, onCancel: onCancel, getAccounts: options.getAccounts }) })), div);
    });
}
//# sourceMappingURL=openModal.js.map